export const DEFAULT_DISTANCE = 15000

export const distancePerState = state => {
  const stateDistance = {
    vic: 25000,
    sa: 20000,
    wa: 20000,
    auckland: 20000,
    christchurch: 20000,
  }
  return stateDistance[state.toLowerCase()] || DEFAULT_DISTANCE
}
